// Note content is a single Tiptap document, stored as one block via the API.
// The backend stores `Block.content` as a string, so serialize the document
// JSON into that string here.

export const EMPTY_DOC = {
  type: 'doc',
  content: [{ type: 'paragraph' }],
};

export function serializeNoteContent(document) {
  return JSON.stringify(document);
}

export function deserializeNoteContent(content) {
  if (!content) return EMPTY_DOC;
  try {
    const document = JSON.parse(content);
    return document && document.type === 'doc' ? document : EMPTY_DOC;
  } catch {
    return EMPTY_DOC;
  }
}
